import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RolePolicy } from '../models/combined-interfaces.model';
import { RbacAdminService } from '../service/admin-rbac-management.service';

@Component({
  selector: 'app-manage-rbac-roles',
  standalone: true,
  templateUrl: './manage-rbac-roles.component.html',
  styleUrls: ['./manage-rbac-roles.component.css'],
  imports: [CommonModule, FormsModule],
})
export class ManageRbacRolesComponent implements OnInit {
  roles: string[] = [];
  allRolePermissions: RolePolicy[] = [];
  selectedRole: string | null = null;
  selectedRoutes: string[] = [];
  unsavedChanges = false;

  routeOptions: string[] = [
    '/admin/manage-products',
    '/admin/manage-categories',
    '/admin/manage-users',
    '/admin/manage-product-groups',
    '/admin/manage-order'
  ];

  constructor(
    private rbacAdminService: RbacAdminService,
    private cdr: ChangeDetectorRef
  ) { }

  async ngOnInit(): Promise<void> {
    const rolePermissions = await this.rbacAdminService.getAllRolePermissions();
    this.allRolePermissions = rolePermissions;
    this.roles = rolePermissions.map((r) => r.role);

    if (this.roles.length > 0) {
      await this.selectRole(this.roles[0]);
    }
  }

  async selectRole(role: string): Promise<void> {
    if (this.unsavedChanges) {
      const discard = confirm('You have unsaved changes. Discard and switch roles?');
      if (!discard) return;
    }

    this.selectedRole = role;

    const entry: any = this.allRolePermissions.find((r) => r.role === role);
    this.selectedRoutes = entry?.permissions ? [...entry.permissions] : [];

    this.unsavedChanges = false;
    console.log(`Switched to ${role} → ${this.selectedRoutes.join(', ')}`);

    this.cdr.detectChanges();
  }



  toggleRoute(route: string): void {
    if (this.selectedRoutes.includes(route)) {
      this.selectedRoutes = this.selectedRoutes.filter((r) => r !== route);
    } else {
      this.selectedRoutes.push(route);
    }

    const roleEntry = this.allRolePermissions.find((r) => r.role === this.selectedRole);
    if (roleEntry) {
      roleEntry.routes = [...this.selectedRoutes];
    }

    this.unsavedChanges = true;
  }

  async save(): Promise<void> {
    if (!this.selectedRole) return;

    const success = await this.rbacAdminService.setRolePermissions(
      this.selectedRole,
      this.selectedRoutes
    );

    if (success) {
      alert('Permissions updated!');
      this.unsavedChanges = false;
    }
  }

  async delete(): Promise<void> {
    if (!this.selectedRole) return;

    const confirmDelete = confirm(`Are you sure you want to delete the role "${this.selectedRole}"?`);
    if (!confirmDelete) return;

    const success = await this.rbacAdminService.deleteRole(this.selectedRole);

    if (success) {
      this.roles = this.roles.filter((r) => r !== this.selectedRole);
      this.allRolePermissions = this.allRolePermissions.filter((r) => r.role !== this.selectedRole);
      this.selectedRole = null;
      this.selectedRoutes = [];
      this.unsavedChanges = false;
    }
  }

  trackByRoute(index: number, route: string): string {
    return route;
  }
}
